import { ResponseClientAdmission, RequestClientAdmission } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { ClientAdmissionActions } from '../actions';
import { ClientAdmissionTypes } from '../../shared/enums';

export interface ClientAdmissionState {
    response: ResponseClientAdmission;
    request: RequestClientAdmission;
    error: any;
}

export const ClientAdmissionInitialState: ClientAdmissionState = {
    response: null,
    request: null,
    error: null
};

const _clientAdmissionReducer = createReducer(
    ClientAdmissionInitialState,

    on(ClientAdmissionActions.getClientAdmission, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(ClientAdmissionActions.getClientAdmissionSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(ClientAdmissionActions.getClientAdmissionError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(ClientAdmissionActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function clientAdmissionReducer(state, action) {
    if (action.type === ClientAdmissionTypes.CAE) {
        state = undefined;
    }
    return _clientAdmissionReducer(state, action);
}
